import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { User } from "./types";

import { RootState } from "lib/store";

const initialState: User | {} = {};

// Slice
export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state: User, action: PayloadAction<User>) {
      Object.assign(state, action.payload);
    },
    logOut(state: User) {
      const newState: User = { ...state };
      Object.keys(newState).forEach((key) => {
        newState[key as keyof User] = null;
      });
      Object.assign(state, newState);
    },
  },
});

export const { setUser, logOut } = userSlice.actions;

const selectSlice = (state: RootState) => state.userSlice || initialState;

export const selectUser = createSelector([selectSlice], (state: User) => state);

export default userSlice.reducer;
